import { SignUp } from '@clerk/clerk-react';

const AcceptInvite = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <SignUp
        forceRedirectUrl="/accept-invite-complete"
        signInUrl="/"
      />
    </div>
  );
};

export default AcceptInvite;
